module.exports = __webpack_public_path__ + "img/swiper1.936b96ea.jpg";